import * as React from 'react';
import type { Maybe, Settings } from '@types/gatsby-types';
import { graphql, useStaticQuery } from 'gatsby';
import CookiebotPartytownScript from 'analytics/components/CookiebotPartytownScript';

const query = graphql`
    query FacebookPixelQuery {
        settings {
            facebook {
                enabled
                pixelId
            }
        }
    }
`;

interface FacebookPixelQuery {
    settings: Maybe<Pick<Settings, 'facebook' | 'enabled'>>;
}

export default function FacebookPixel() {
    const { settings } = useStaticQuery<FacebookPixelQuery>(query);

    const enabled = settings?.facebook?.enabled;
    const pixelId = settings?.facebook?.pixelId;

    if (process.env.NODE_ENV === 'production' && enabled && pixelId) {
        return (
            <CookiebotPartytownScript
                id="facebook-pixel"
                content={`
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
          n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
          t.defer=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
          document,'script','https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}');
          fbq('track', 'PageView');
                `}
                cookieType="marketing"
            />
        );
    }

    return null;
}
